import React, { useEffect, useState } from 'react';
import { Accordion } from '../components/Accordion';
import { CheckCircle2, Star, PenLine } from 'lucide-react';
const HOTMART_URL = 'https://pay.hotmart.com/G104193320C';
const modules = [{
  src: 'https://cdn.magicpatterns.com/uploads/oaZETDAm6QZkvwW2z9B84A/MOCKUP_SANTUARIO_DE_CALMA_PORTADA_HOTMART.png',
  title: 'Sistema 30 días'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/nd5nS7DNN6GaZEyxoVTnvV/76F6895B-2B15-4C86-A49E-5B2AB15802A1.png',
  title: 'Audios de frecuencias'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/pVwK8962u3Zgf1JmrUWXFo/MOCKUP_PRESENTACION_SANTUARIO_DE_CALMA.png',
  title: 'Masterclass'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/d5vkYuj119FF5B35K56gNR/MOCKUP_365_EN_CONEXION_1.1.png',
  title: 'Journaling guiado'
}];
const benefits = ['Menos ansiedad mental', 'Mejor descanso', 'Más claridad emocional', 'Herramientas rápidas', 'Rutina diaria guiada'];
const faqItems = [{
  title: '¿Cómo recibo el acceso?',
  content: 'Acceso inmediato y completo a todo el contenido digital desde tu área de miembro, nada más completar la compra.'
}, {
  title: '¿Cuánto tiempo necesito al día?',
  content: 'Entre 5 y 15 minutos. El sistema está diseñado para adaptarse a tu ritmo.'
}, {
  title: '¿Esto sustituye terapia?',
  content: 'No. Es un complemento de bienestar personal. No reemplaza la atención médica o psicológica profesional.'
}];
const legalItems = [{
  title: 'Política de Privacidad',
  content: 'En Santuario de Calma, nos tomamos muy en serio tu privacidad. Tus datos personales serán tratados con la máxima confidencialidad y solo se utilizarán para gestionar tu acceso al curso y enviarte comunicaciones relacionadas. No compartimos tus datos con terceros sin tu consentimiento explícito.'
}, {
  title: 'Términos y Condiciones',
  content: 'Al adquirir este producto digital, obtienes una licencia personal e intransferible para su uso. Queda prohibida la reproducción, distribución o venta del contenido sin autorización previa. El acceso es de por vida para la versión actual del producto.'
}];
export function LandingPage() {
  const [showStickyCTA, setShowStickyCTA] = useState(false);
  const [timeLeft, setTimeLeft] = useState(10 * 60); // 10 minutes in seconds
  useEffect(() => {
    const handleScroll = () => setShowStickyCTA(window.scrollY > 600);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = String(Math.floor(timeLeft / 60)).padStart(2, '0');
  const seconds = String(timeLeft % 60).padStart(2, '0');
  const isExpired = timeLeft === 0;
  return <div className="min-h-screen bg-cream text-charcoal font-sans selection:bg-gold-500 selection:text-white pb-20 md:pb-0" data-id="element-11">
      {/* ── 1. HERO ── */}
      <section className="relative w-full overflow-hidden" data-id="element-12">
        {/* Hero image — full width, natural aspect ratio */}
        <img src="https://cdn.magicpatterns.com/uploads/u4tiiyV9q9GcoK7CEVnp4u/HERO_1_SANTUARIO_DE_CALMA.png" alt="Santuario de Calma — La calma que no lograste en meses, en días" className="w-full block" style={{
        position: 'relative',
        zIndex: 1
      }} data-id="element-13" />
      </section>

      {/* ── COUNTDOWN BANNER ── */}
      <div className="w-full bg-gradient-to-r from-charcoal via-dark-800 to-charcoal border-b border-gold-500/20 py-4 px-4 text-center" data-id="element-14">
        {isExpired ? <p className="text-gold-400 font-medium text-sm md:text-base tracking-wide" data-id="element-15">
            ⏰ La oferta especial ha expirado —{' '}
            <a href={HOTMART_URL} target="_blank" rel="noopener noreferrer" className="underline hover:text-gold-300 transition-colors" data-id="element-16">
              Comprueba disponibilidad
            </a>
          </p> : <div className="flex flex-col items-center gap-4" data-id="element-17">
            {/* Timer row */}
            <div className="flex items-center justify-center gap-3 flex-wrap" data-id="element-18">
              <span className="text-gold-400 text-sm md:text-base font-medium tracking-wide uppercase" data-id="element-19">
                🔥 Oferta especial termina en:
              </span>
              <div className="flex items-center gap-1.5" data-id="element-20">
                <div className="bg-gold-500 text-white font-serif font-bold text-xl md:text-2xl w-10 md:w-12 h-10 md:h-12 rounded-lg flex items-center justify-center shadow-[0_0_12px_rgba(212,175,55,0.3)] tabular-nums" data-id="element-21">
                  {minutes}
                </div>
                <span className="text-gold-400 font-bold text-xl" data-id="element-22">:</span>
                <div className="bg-gold-500 text-white font-serif font-bold text-xl md:text-2xl w-10 md:w-12 h-10 md:h-12 rounded-lg flex items-center justify-center shadow-[0_0_12px_rgba(212,175,55,0.3)] tabular-nums" data-id="element-23">
                  {seconds}
                </div>
              </div>
            </div>

            {/* CTA button — below countdown, glowing border */}
            <div className="relative" data-id="element-24">
              {/* Outer glow ring */}
              <div className="absolute -inset-1 rounded-full bg-gradient-to-r from-gold-400 via-gold-500 to-gold-400 opacity-70 blur-sm animate-pulse pointer-events-none" data-id="element-25" />
              <a href={HOTMART_URL} target="_blank" rel="noopener noreferrer" className="relative inline-flex items-center justify-center bg-gold-500 hover:bg-gold-600 text-white font-semibold text-lg md:text-xl px-12 md:px-16 py-4 rounded-full transition-all duration-300 transform hover:scale-105 uppercase tracking-wide whitespace-nowrap shadow-[0_0_30px_rgba(212,175,55,0.5)] border-2 border-gold-400/60 focus:outline-none focus:ring-2 focus:ring-gold-300 focus:ring-offset-2 focus:ring-offset-charcoal" style={{
            zIndex: 3
          }} data-id="element-26">
                Quiero empezar hoy
              </a>
            </div>

            <p className="text-neutral-600 text-xs" data-id="element-27">
              Pago único · Acceso inmediato · Compra segura
            </p>
          </div>}
      </div>

      {/* ── 2. BENEFICIOS ── */}
      <section className="py-16 md:py-20 px-6 bg-cream" data-id="element-28">
        <div className="max-w-xl mx-auto" data-id="element-29">
          <div className="h-px w-16 bg-gold-500/40 mx-auto mb-10" data-id="element-30" />
          <ul className="space-y-5" data-id="element-31">
            {benefits.map((b, i) => <li key={i} className="flex items-center gap-4" data-id="element-32">
                <CheckCircle2 className="w-6 h-6 text-gold-600 flex-shrink-0" data-id="element-33" />
                <span className="text-xl md:text-2xl font-serif text-charcoal/80" data-id="element-34">
                  {b}
                </span>
              </li>)}
          </ul>
          <div className="h-px w-16 bg-gold-500/40 mx-auto mt-10" data-id="element-35" />
        </div>
      </section>

      {/* ── 3. QUÉ INCLUYE ── */}
      <section className="py-16 md:py-20 px-6 bg-parchment" data-id="element-36">
        <div className="max-w-5xl mx-auto" data-id="element-37">
          <h2 className="text-[26px] md:text-[38px] font-serif text-charcoal text-center mb-12" data-id="element-38">
            Qué incluye
          </h2>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8" data-id="element-39">
            {modules.map((m, i) => <div key={i} className="flex flex-col items-center text-center gap-4" data-id="element-40">
                <div className="w-full aspect-[4/5] rounded-xl overflow-hidden border border-gold-500/15 bg-white/50 shadow-sm" data-id="element-41">
                  <img src={m.src} alt={m.title} className="w-full h-full object-cover" data-id="element-42" />
                </div>
                <span className="text-base md:text-lg font-serif text-charcoal leading-snug" data-id="element-43">
                  {m.title}
                </span>
              </div>)}
          </div>
        </div>
      </section>

      {/* ── 4. BLOQUE PRECIO CENTRAL ── */}
      <section id="compra" className="py-20 md:py-28 px-6 bg-gradient-to-b from-charcoal to-ink text-center relative overflow-hidden" data-id="element-44">
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[500px] h-[300px] bg-gold-500/10 rounded-full blur-[100px] pointer-events-none" data-id="element-45" />

        <div className="relative z-10 max-w-lg mx-auto space-y-8" data-id="element-46">
          <h2 className="text-[30px] md:text-[46px] font-serif text-cream leading-tight" data-id="element-47">
            Empieza hoy tu Sistema de 30 Días
          </h2>

          <div className="flex items-baseline justify-center gap-5" data-id="element-48">
            <span className="text-2xl text-neutral-600 font-serif line-through" data-id="element-49">
              39€
            </span>
            <span className="text-5xl md:text-6xl font-serif text-white font-semibold" data-id="element-50">
              9,99€
            </span>
          </div>

          <p className="text-neutral-500 text-sm" data-id="element-51">
            Pago único · Acceso inmediato · Para siempre
          </p>

          <a href={HOTMART_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full md:w-auto bg-gold-500 hover:bg-gold-600 text-white font-semibold text-xl px-14 py-5 rounded-full transition-all duration-300 transform hover:scale-105 hover:shadow-[0_0_30px_rgba(212,175,55,0.4)] uppercase tracking-wide" data-id="element-52">
            Acceder ahora
          </a>

          <p className="text-neutral-600 text-xs" data-id="element-53">
            Compra segura · Acceso inmediato
          </p>
        </div>
      </section>

      {/* ── 5. FAQ ── */}
      <section className="py-16 md:py-20 px-6 bg-cream" data-id="element-54">
        <div className="max-w-2xl mx-auto" data-id="element-55">
          <h2 className="text-[26px] md:text-[38px] font-serif text-center text-charcoal mb-10" data-id="element-56">
            Preguntas Frecuentes
          </h2>
          <Accordion items={faqItems} data-id="element-57" />
        </div>
      </section>

      {/* ── 6. CTA FINAL ── */}
      <section className="py-16 md:py-20 px-6 bg-parchment text-center" data-id="element-58">
        <div className="max-w-lg mx-auto space-y-6" data-id="element-59">
          <h2 className="text-[26px] md:text-[38px] font-serif text-charcoal" data-id="element-60">
            ¿Listo para empezar?
          </h2>
          <a href={HOTMART_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full md:w-auto bg-gold-500 hover:bg-gold-600 text-white font-semibold text-xl px-14 py-5 rounded-full transition-all duration-300 transform hover:scale-105 hover:shadow-[0_0_24px_rgba(212,175,55,0.3)] uppercase tracking-wide" data-id="element-61">
            Comprar ahora — 9,99€
          </a>
          <p className="text-charcoal/40 text-xs" data-id="element-62">
            Pago único · Acceso inmediato · Compra segura
          </p>
        </div>
      </section>

      {/* ── LEGAL ── */}
      <section className="py-10 px-6 bg-cream border-t border-gold-500/10" data-id="element-63">
        <div className="max-w-2xl mx-auto" data-id="element-64">
          <h3 className="text-xs font-medium text-charcoal/40 uppercase tracking-widest mb-6 text-center" data-id="element-65">
            Información Legal
          </h3>
          <Accordion items={legalItems} data-id="element-66" />
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer className="py-8 text-center text-neutral-500 text-sm bg-charcoal" data-id="element-67">
        <p data-id="element-68">© 2025 Santuario de Calma. Todos los derechos reservados.</p>
      </footer>

      {/* ── STICKY MOBILE CTA ── */}
      <div className={`fixed bottom-0 left-0 w-full h-16 bg-charcoal/95 backdrop-blur-sm border-t border-gold-500/20 z-50 flex items-center justify-center px-4 transition-transform duration-300 md:hidden ${showStickyCTA ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-69">
        <a href={HOTMART_URL} target="_blank" rel="noopener noreferrer" className="w-full bg-gold-500 text-white rounded-full text-base font-semibold px-6 py-2.5 text-center shadow-lg uppercase tracking-wide" data-id="element-70">
          9,99€ — Comprar ahora
        </a>
      </div>
    </div>;
}